import { render, staticRenderFns } from "./CompetitionLogo.vue?vue&type=template&id=4390e746&scoped=true"
import script from "./CompetitionLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionLogo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4390e746",
  null
  
)

export default component.exports